import { observer } from 'mobx-react';
import { useRootStore } from 'stores';
import { Optional } from 'utils/Optional';
import { Loader } from 'components/Loader';
import { useQuery } from '@apollo/react-hooks';
import { ErrorPage } from 'components/ErrorPage';
import { ME_QUERY, MeQuery, UserType } from 'api';
import Authentication from 'services/Authentication';
import React, { Fragment, useEffect, useState } from 'react';

interface Props {
  children: React.ReactNode | React.ReactNode[];
}

const User: React.FC<Props> = ({ children }: Props) => {
  const store = useRootStore();

  const [error, setError] = useState<Optional<Error>>(null);

  const { loading, data } = useQuery<MeQuery>(ME_QUERY, { fetchPolicy: 'network-only', onError: setError });

  useEffect(() => {
    if (!data || !data.me) return;

    if (data.me.userType !== UserType.CSM) {
      Authentication.signOut();
    } else {
      store.user.initializeUser(data.me);
    }
  }, [data]);

  if (loading && !store.user.user) {
    return <Loader />;
  }

  if (store.user.user) {
    return <Fragment>{children}</Fragment>;
  }

  if (error) {
    return <ErrorPage error={error} />;
  }

  return null;
};

export const UserContainer = observer(User);
